'use strict';

angular.module('ClinicApp').directive('userPrimeMembership', function(
  $state,
  $q,
  $timeout,
  OpencareConstants,
  MembershipService,
  GrowlService,
) {
  return {
    restrict: 'A',
    templateUrl: '/views/directives/_user-prime-membership.html',
    scope: {
      userClinics: '=',
    },
    link: function($scope) {
      $scope.APPOINTMENT_PRICE_TYPE = OpencareConstants.clinicMembership.appointmentPriceType;

      const getClinicSortKey = (clinic) => `${clinic.membership?.plan} ${clinic.name} ${clinic.id}`;
      const clinicsCompareFn = (clinicA, clinicB) => getClinicSortKey(clinicA).localeCompare(getClinicSortKey(clinicB));

      $scope.clinicsWithMembership = $scope.userClinics
        .filter((clinic) => clinic.membership)
        .sort(clinicsCompareFn);
      $scope.clinicsWithoutMembership = $scope.userClinics
        .filter((clinic) => !clinic.membership)
        .sort(clinicsCompareFn);

      $scope.billingRunCheckResults = {};
      $scope.paymentMethodChange = {};

      $scope.startPaymentMethodChange = (clinic) => {
        $scope.paymentMethodChange = {
          loading: clinic.id,
        };

        return MembershipService.listPaymentMethods(clinic.id)
          .then((paymentMethods) => {
            $scope.paymentMethodChange.clinicId = clinic.id;
            $scope.paymentMethodChange.paymentMethods = paymentMethods || [];
          })
          .finally(() => {
            $scope.paymentMethodChange.loading = null;
          });
      };

      $scope.cancelPaymentMethodChange = () => {
        $scope.paymentMethodChange = {};
      };

      $scope.submitPaymentMethod = (clinic, type, data) => {
        if (!clinic.membership) {
          return createMembership(clinic, type, data).then(() => {
            $scope.cancelPaymentMethodChange();
            $state.reload();
          });
        }
        return updatePaymentMethod(clinic, type, data).then(() => {
          $scope.cancelPaymentMethodChange();
        });
      };

      $scope.runBilling = async (clinic) => {
        const billingRunCheckResult = $scope.billingRunCheckResults[clinic.id];

        if (!billingRunCheckResult?.available) {
          return $q.reject();
        }

        billingRunCheckResult.waiting = true;
        try {
          const billingRunResult = await MembershipService.runBilling(clinic.id, {
            year: billingRunCheckResult.year,
            month: billingRunCheckResult.month,
          });
          await checkBillingRun(clinic.id);

          if (billingRunResult.succeed) {
            GrowlService.success('Billing was successfully completed. We will reactivate your practice account soon, allowing you to continue receiving new patient requests.');
          }
        } finally {
          billingRunCheckResult.waiting = false;
        }
      };

      function getPaymentMethodPayload(type, data) {
        const payload = {
          type,
        };
        if (data.id) {
          payload.id = data.id;
        } else if (type === OpencareConstants.paymentMethod.type.CARD) {
          payload.card = data;
        }
        return payload;
      }

      function createMembership(clinic, paymentMethodType, paymentMethodData) {
        return MembershipService.createDefault(clinic.id, {
          paymentMethod: getPaymentMethodPayload(paymentMethodType, paymentMethodData),
        }).then((createdMembership) => {
          clinic.membership = createdMembership;
        });
      }

      function updatePaymentMethod(clinic, paymentMethodType, paymentMethodData) {
        return MembershipService.updatePaymentMethod(
          clinic.id,
          clinic.membership.id,
          getPaymentMethodPayload(paymentMethodType, paymentMethodData),
        ).then((updatedMembership) => {
          clinic.membership.billingCard = updatedMembership.billingCard;
        });
      }

      async function checkBillingRun(clinicId = null) {
        const clinics = ($scope.clinicsWithMembership ?? [])
          .filter((clinic) => !clinicId || clinic.id === clinicId);

        const billingRunCheckResults = await $q.all(
          clinics.map((clinic) => MembershipService.checkBillingRun(clinic.id)),
        );

        clinics.forEach((clinic, index) => {
          const billingRunCheckResult = billingRunCheckResults[index];
          billingRunCheckResult.show = billingRunCheckResult.available || billingRunCheckResult.availableAfter;
          $scope.billingRunCheckResults[clinic.id] = billingRunCheckResult;
        });
      }

      $timeout(async () => {
        await checkBillingRun();
      });
    },
  };
});
